<template>
  <div class="home">
    <div class="home-student">
      <el-dropdown>
        <div class="el-dropdown-link home-student__icon" style="font-size: 20px">
          {{userName}}
        </div>
        <el-dropdown-menu slot="dropdown" v-if="Number(loginType) !== 1">
          <el-dropdown-item>
            <span @click="loginOut" class="home-student__name">
              <i class="icon icon-out"></i>
              <span style="vertical-align: super;">退出</span>
            </span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <header class="home-header">欢迎使用  智适应教学平台</header>
    <section class="home-content">
      <div class="home-adapt" v-if="Number(schoolType) !== 30">
        <div class="home-adapt__header">智适应个性化学习</div>
        <div class="home-adapt__content">
          <div
            v-for="(item, index) in adaptList"
            :key="index"
            :class="[item.icon]"
            @click="jumpModule(item, 'adapt')"
            class="home-adapt__content__list">
          </div>
        </div>
      </div>
      <div class="home-adapt" v-if="Number(schoolType) !== 31">
        <div class="home-adapt__header">精准学任务</div>
        <div class="home-adapt__content">
          <div
            v-for="(item, index) in jzjxList"
            :key="index"
            @click="jumpModule(item, 'jzjx')"
            :class="[item.icon]"
            class="home-adapt__content__list">
          </div>
        </div>
      </div>
      <div v-if="schoolEntranceUrl !== ''" @click="jumpSchool" class="home-school"></div>
    </section>
  </div>
</template>

<script>
import api from '@/pages/uc-web/api/api';
import _ from 'lodash';
import { openTab, isApp, jsBridgeForSSAI } from '@/utils/index';

export default {
  name: 'HomePage',
  data() {
    return {
      adaptList: [
      ],
      jzjxList: [
      ],
      schoolType: '',
      adaptEvaluate: [],
      jzjxStudentCenter: [],
      userName: '',
      apkList: [],
      schoolEntranceUrl: '',
      loginType: 0,
    };
  },
  created() {
    if (isApp()) {
      jsBridgeForSSAI('requestPermissions', ['android.permission.RECORD_AUDIO', 'android.permission.READ_EXTERNAL_STORAGE']);
    }
    this.getMenuList();
  },
  mounted() {
    window.getLoginType = this.getLoginType;
    if (isApp()) {
      jsBridgeForSSAI('getData', {
        key: 'loginType',
      }, 'getLoginType');
    }
  },
  methods: {
    getLoginType(data) {
      if (data !== undefined) {
        console.log(data, 'apk返回');
        this.loginType = JSON.parse(data).data.loginType;
      }
    },
    async getMenuList() {
      const bigLoginParams = JSON.parse(localStorage.getItem('BigLoginParams')) || {};
      const host = `https://${window.location.host}`;
      const ActiveLogin = this.$route.query.action === 'login';
      console.log(bigLoginParams.action, 'action');
      let params;
      if (bigLoginParams.action === 'module') {
        params = {
          action: 'module',
        };
      } else if (bigLoginParams.action === 'study') {
        params = {
          action: 'study',
          task_id: bigLoginParams.task_id,
        };
      } else {
        params = {
          action: 'login',
        };
      }
      let res;
      try {
        res = await api.getMenuList(params);
        localStorage.getItem('schoolType', res.data.school_type); // type==31||type==32||type==33 去往学生中心主界面
        localStorage.setItem('real_name', res.data.real_name);
        localStorage.setItem('account_id', res.data.account_id);
        localStorage.setItem('school_id', res.data.school_id);
        localStorage.setItem('user_token', res.data.user_token);
        localStorage.setItem('school_nature_id', res.data.school_nature_id);
        this.schoolType = res.data.school_type;
        if (Number(this.schoolType) !== 31) {
          this.jzjxList = [
            // { icon: 'test', module: 1 },
            { icon: 'preview', module: 2 },
            // { icon: 'exercise', module: 3 },
            { icon: 'none', module: 0 },
            { icon: 'none', module: 0 },
            { icon: 'none', module: 0 },
          ];
        }
        // 上下两个数组内的icon由钱盾写死
        if (Number(this.schoolType) !== 30) {
          this.adaptList = [
            { icon: 'study', module: 1 },
            { icon: 'report', module: 2 },
            { icon: 'error', module: 3 },
            { icon: 'review', module: 4 },
          ];
          this.schoolEntranceUrl = _.get(res, 'data.ai_evaluate[4].url', '');
          console.log(this.schoolEntranceUrl, 'zhishi', res.data.ai_evaluate[4]);
        }
        this.userName = res.data.real_name;
        this.adaptEvaluate = res.data.ai_evaluate;
        this.jzjxStudentCenter = res.data.student_center;
        this.showList(res, host);
        this.getSSAI(res, host);
        const module = bigLoginParams.module || 0;
        if (module > 4 && module !== '' && !ActiveLogin) {
          let num;
          if (Number(module) === 5) num = 2;
          if (Number(module) === 6) num = 3;
          if (Number(module) === 7) num = 1;
          console.log(num, 'num');
          localStorage.setItem('changeId', num);
          this.$router.push({
            path: '/uc-web/center',
          });
        }
        // module 去往具体模块
        if (module < 5 && module > 0 && !ActiveLogin) {
          const { url } = this.adaptEvaluate.filter(
            (item) => Number(item.module) === Number(module),
          )[0];
          openTab(url);
        }
        if (bigLoginParams.action === 'study' && !ActiveLogin) {
          // mt作业
          if (res.data.study.type === 3) {
            // 文科同步练习
            if (res.data.study.subject_id === 1 || res.data.study.subject_id === 3) {
              openTab(encodeURI(`${host}/artsSelf/welcome?jupiterToken=${res.data.study.token}&realname=${res.data.real_name}`));
              return;
            }
            // 理科同步练习
            openTab(encodeURI(`${host}/mt-web/welcome?jupiterToken=${res.data.study.token}&realname=${res.data.real_name}`));
          } else {
            openTab(encodeURI(`${host}/amt-web/welcome?jupiterToken=${res.data.study.token}&realname=${res.data.real_name}`));
          }
        } // study去往题目流程
      } catch (error) {
        console.log(error);
      }
    },
    jumpModule(value, type) {
      if (value.module === 0) return;
      if (type === 'jzjx') {
        this.$router.push({
          path: '/uc-web/center',
        });
        console.log(value.module, 'number');
        localStorage.setItem('changeId', value.module);
      } else {
        console.log(value);
        const { url } = this.adaptEvaluate.filter((item) => item.module === value.module)[0];
        console.log(url, 'url');
        openTab(url);
      }
    },
    getSSAI(res, host) {
      const UCINFO = {
        real_name: res.data.real_name,
        account_id: res.data.account_id,
        school_id: res.data.school_id,
        user_token: res.data.user_token,
        school_nature_id: res.data.school_nature_id,
        school_type: res.data.school_type,
        school_use_type: res.data.school_use_type,
      };
      if (isApp()) {
        jsBridgeForSSAI('floatButton', {
          visibility: 1, // 1.显示按钮；0不显示
          homeUrl: `${host}/uc-web/homePage`, // 回首页的链接
        });
        jsBridgeForSSAI('setHomeUrl', {
          homeUrl: `${host}/uc-web/homePage?action=login`, // 回首页的链接
        });
        jsBridgeForSSAI('floatButton', {
          visibility: 1, // 1.显示按钮；0不显示
          homeUrl: `${host}/uc-web/homePage?action=login`, // 回首页的链接
        });
        jsBridgeForSSAI('setData', {
          key: 'UCINFO',
          value: UCINFO,
        });
        // jsBridgeForSSAI('setHomeUrl', {
        //   homeUrl: `${host}/uc-web/homePage`, // 回首页的链接
        // });
        jsBridgeForSSAI('setData', {
          key: 'user_token',
          value: res.data.user_token,
        });
        jsBridgeForSSAI('loadNavigation', this.apkList);
      }
    },
    showList(res, host) {
      let apkAdaptList = [];
      let apkJzjxList = [];
      if (this.schoolType !== 30) {
        apkAdaptList = [{
          title: '智适应个性化学习',
          url: '',
          iconUrl: '',
          sub_menu: [{
            title: '学习中心',
            url: `${res.data.ai_evaluate[0].url}`,
            iconUrl: 'http://file1.classba.cn/learn-center-jzjxapp2x.png',
            sub_menu: [],
          },
          {
            title: '我的报告',
            url: `${res.data.ai_evaluate[1].url}`,
            iconUrl: 'http://file1.classba.cn/report-center-jzjxapp2x.png',
            sub_menu: [],
          },
          {
            title: '错题训练营',
            url: `${res.data.ai_evaluate[2].url}`,
            iconUrl: 'http://file1.classba.cn/wrongbook-jzjxapp2x.png',
            sub_menu: [],
          },
          {
            title: '课后复习',
            url: `${res.data.ai_evaluate[3].url}`,
            iconUrl: 'http://file1.classba.cn/review-jzjxapp2x.png',
            sub_menu: [],
          }],
        }];
      }
      if (this.schoolType !== 31) {
        apkJzjxList = [{
          title: '精准教学任务',
          url: '',
          iconUrl: '',
          sub_menu: [{
            title: '课前预习',
            url: `${host}/uc-web/center?changeId=2`,
            iconUrl: 'http://file1.classba.cn/preview-jzjxapp2x.png',
            sub_menu: [],
          },
          /* {
            title: '练习中心',
            url: `${host}/uc-web/center?changeId=3`,
            iconUrl: 'http://file1.classba.cn/hw-center-jzjxapp2x.png',
            sub_menu: [],
          }, */
          // {
          //   title: '测评中心',
          //   url: `${host}/uc-web/center?changeId=1`,
          //   iconUrl: 'http://file1.classba.cn/test-center-jzjxapp2x.png',
          //   sub_menu: [],
          // },
          ],
        }];
      }
      this.apkList = [...apkAdaptList, ...apkJzjxList];
    },
    jumpSchool() {
      openTab(this.schoolEntranceUrl);
    },
    loginOut() {
      if (isApp()) {
        jsBridgeForSSAI('removeData', {
          key: 'user_token',
        });
      }
      localStorage.removeItem('user_token');
      localStorage.removeItem('ddToken');
      this.$router.push({
        path: '/uc-web/login',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .el-dropdown {
    display: block;
    color: #fff;
    font-size: 16px;
  }
  .home {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: url('../images/homePagebg.png') no-repeat center/ 100% 100%;
    color: #fff;
    font-family: PingFangSC-Semibold, PingFang SC;
    &-student {
      position: absolute;
      // width: 170px;
      height: 46px;
      border-radius: 10px;
      right: 10%;
      top: 2%;
      text-indent: 3rem;
      line-height: 46px;
      &__icon {
        background: url('../images/studentIcon.png') no-repeat left top / contain;
      }
      &__name {
        position: relative;
        font-size: 16px;
        top: -2px;
      }
    }
    &-header {
      position: absolute;
      left: 50%;
      top: 10%;
      transform: translateX(-50%);
      width: 50%;
      font-size: 26px;
      font-weight: 600;
      text-align: center;
      background: url('../images/titleBg.png') no-repeat center/ 100% 7px;
    }
    &-content {
      height: 90vh;
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
      padding: 9rem 118px 0;
    }
    &-adapt {
      // flex: 1;
      height: 40%;
      // margin-bottom: 3rem;
      &__header {
        font-size: 20px;
        font-weight: 600;
        text-indent: 2rem;
      }
      &__content {
        height: 100%;
        display: flex;
        justify-content: space-evenly;
        &__list {
          width: 23.30rem;
          min-height: 25%;
          // margin-right: 2%;
          border-radius: 10px;
          background-color: #fff;
          cursor: pointer;
        }
      }
    }
    &-school {
      position: fixed;
      width: 150px;
      height: 150px;
      background: url('../images/schoolSongshu.png') no-repeat center / contain;
      border-radius: 50%;
      right: 50px;
      bottom: 100px;
    }
    .study {
      background: url('../images/studyBg.png') no-repeat;
      background-size: contain;
    }
    .report {
      background: url('../images/reportBg.png') no-repeat;
      background-size: contain;
    }
    .error {
      background: url('../images/ErrorTopicBg.png') no-repeat;
      background-size: contain;
    }
    .review {
      background: url('../images/reviewBg.png') no-repeat;
      background-size: contain;
    }
    .preview {
      background: url('../images/previewBg.png') no-repeat;
      background-size: contain;
    }
    .exercise {
      background: url('../images/exerciseBg.png') no-repeat;
      background-size: contain;
    }
    .test {
      background: url('../images/testBg.png') no-repeat;
      background-size: contain;
    }
    .none {
      opacity: 0;
    }
  }
</style>
